import { createBigDecimal } from '@0xtorch/big-decimal'
import { z } from 'zod'
import { responseDataSchema, successResponseSchema } from '../schema'

const tradeSchema = z.object({
  /** symbol, e.g. "BTC-USDT" */
  symbol: z.string(),
  /** trade id, it is generated by Matching engine., e.g. "5c35c02709e4f67d5266954e" */
  tradeId: z.string(),
  /** Order ID, unique identifier of an order., e.g. "5c35c02703aa673ceec2a168" */
  orderId: z.string(),
  /** counter order id, e.g. "5c1ab46003aa676e487fa8e3" */
  counterOrderId: z.string(),
  /** transaction direction */
  side: z.union([z.literal('buy'), z.literal('sell')]),
  /** order price, e.g. "0.083" */
  price: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** order quantity, e.g. "0.8424304" */
  size: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** order funds, e.g. "0.0699217232" */
  funds: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** order type,e.g. limit,market,stop_limit. */
  type: z.string(),
  /** fee, e.g. "0" */
  fee: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** charge fee currency, e.g. "USDT" */
  feeCurrency: z.string(),
  /** stop type, include entry and loss */
  stop: z.string().nullable().optional(),
  liquidity: z.union([z.literal('taker'), z.literal('maker')]),
  /** forced to become taker */
  forceTaker: z.boolean(),
  /** create time */
  createdAt: z.number().int(),
  /** The type of trading */
  tradeType: z.union([
    z.literal('TRADE'),
    z.literal('MARGIN_TRADE'),
    z.literal('MARGIN_ISOLATED_TRADE'),
  ]),
})

export type Trade = z.infer<typeof tradeSchema>

export const tradeResponseSchema = successResponseSchema.extend({
  data: responseDataSchema.extend({
    items: z.array(tradeSchema),
  }),
})
